export const
    //GENERAL
    BREAKPOINT_CHANGE = 'BREAKPOINT_CHANGE',
    TOGGLE_TRIGGERED = 'TOGGLE_TRIGGERED',
    //FILTERS
    PILL_REMOVED = 'PILL_REMOVED',
    FILTER_CHANGED = 'FILTER_CHANGED',
    FILTER_INIT = 'FILTER_INIT',
    FILTERAPI_FAILED = 'FILTERAPI_FAILED',
    UPDATE_SEARCH = 'UPDATE_SEARCH',
    //SHOP
    ADDTOCART_FAILED = 'ADDTOCART_FAILED',
    ADD_TO_CART = 'ADD_TO_CART',
    //VOTE
    VOTE_SUBMITTED = 'VOTE_SUBMITTED'
    ;